// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App__1o-Fp","App-logo":"App__App-logo__3JCPt","App-header":"App__App-header__3iH8L"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 84
// module chunks = 0